<template>
    <div>
        <!-- <alert-loading></alert-loading> -->
        <b-row align-h="between">
            <b-col>
                <el-date-picker 
                    v-model="reportDate"
                    align="right" 
                    placeholder="Na dzień"
                    class="date-picker-inline">
                </el-date-picker>
            </b-col>
            <b-col class="text-right">
                <b-button variant="default" @click.prevent="downloadReport()">
                    <span>Generuj XLS</span>
                    <svg-icon name="download"/>
                </b-button>
            </b-col>
        </b-row>
        <alert-loading v-if="loading"></alert-loading>
        <div v-if="!loading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
                <thead>
                <tr>
                    <th>Klient</th>
                    <th>Kwota ({{currency.name}})</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="item in items.customers">
                        <td class="td-no_link">{{item.customerName}}</td>
                        <td class="td-no_link">{{item.amount}} </td>
                    </tr>

                </tbody>
                <tfoot>
                    <tr class="tr-summary">
                        <td class="td-no_link text-right">Razem</td>
                        <td class="td-no_link"><strong>{{items.total}}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'
  import http from './../../utils/http'

  export default {
    props: {
      currency: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        reportDate: null
      };
    },

    methods: {
      downloadReport(){
        const to =  moment(this.reportDate).format('YYYY-MM-DD')
        http.download('/download/reports/debts/' + this.currency.id + '?to=' + to + '&');
      },

      ...mapActions({
        getItems: 'report/debts/getItems'
      })
    },

    computed: {
      ...mapGetters({
        items: 'report/debts/items',
        loading: 'report/debts/loading',
        errors: 'report/debts/errors',
      })
    },
    watch:{
      reportDate: function (data) {
        this.getItems({ currency: this.currency, to: this.reportDate} )
      }
    },
    created () {
      if(!this.reportRange){
        this.reportDate = new Date();
      }
    }
  };
</script>


// WEBPACK FOOTER //
// Debts.vue?76e8e200